import axios from 'axios';
import * as qs from 'qs';

import { objFilter, typeOf } from '../utils/object';

const createInterceptor = (initialParams, withExport = false) => {
  const axiosInstance = axios.create(initialParams);

  axiosInstance.defaults.paramsSerializer = {
    serialize: (params) => {
      const newParams = objFilter(params, (paramKey, paramValue) => (
        !(paramValue === '' || paramKey.endsWith('_aux'))
      ));
      return qs.stringify(newParams, { indices: false });
    },
    indexes: null,
  };

  axiosInstance.defaults.withCredentials = initialParams.withCredentials || false;
  axiosInstance.defaults.headers.common['Content-Type'] = 'application/json';
  axiosInstance.defaults.headers.common.Accept = 'application/json';

  axiosInstance.interceptors.request.use((config) => {
    if (config.data && config.data instanceof FormData) {
      // eslint-disable-next-line no-param-reassign
      config.headers['Content-Type'] = 'multipart/form-data';
      return config;
    }

    let configData = config.data;

    if (config.data && typeOf(config.data) === 'object') {
      configData = objFilter(config.data, (dataKey, dataValue) => (
        !(dataValue === '' || dataKey.endsWith('_aux'))
      ));
    }

    return {
      ...config,
      data: configData,
    };
  }, (error) => Promise.reject(error));

  axiosInstance.interceptors.response.use((res) => {
    if (withExport || initialParams.withStatus) return res;
    return res.data;
  }, (error) => Promise.reject(error));

  return axiosInstance;
};

export default createInterceptor;
